import { useEntitlements } from "@/hooks/use-entitlements"
import { UpgradePrompt } from "@/components/app/UpgradePrompt"

export function FeatureGate({ feature, children, title, description }) {
  const { hasFeature } = useEntitlements()
  if (!hasFeature(feature)) {
    return (
      <div className="min-h-screen bg-background">
        <UpgradePrompt feature={feature} title={title} description={description} />
      </div>
    )
  }
  return children
}
